import { useLocalStorage } from "usehooks-ts";

type ColumnSizes = Record<string, number>;

export const useColumnSizes = (nodeId: string) => {
  const [columnSizes, setColumnSizes] = useLocalStorage<ColumnSizes>(
    `dt-column-sizes-${nodeId}`,
    {},
  );

  return { columnSizes, setColumnSizes };
};
